import PrimaryPalette from '../../birch/colors';
import { colors } from '../constants';

const azaleaTheme = {
  default: {
    borderColor: colors.lightGrey,
    hoverBorderColor: colors.lightGrey,
    textColor: colors.darkestGrey,
    backgroundColor: colors.white,
    hoverColor: colors.lightestGrey,
    iconColor: colors.mediumGrey,
    iconHoverColor: colors.darkestGrey,
    iconHoverBGColor: colors.lightBlue,
  },
  error: {
    borderColor: colors.darkRed,
    hoverBorderColor: colors.darkRed,
    textColor: colors.darkRed,
    backgroundColor: colors.white,
    hoverColor: colors.lightestGrey,
    iconColor: colors.mediumGrey,
    iconHoverColor: colors.darkestGrey,
    iconHoverBGColor: colors.lightBlue,
  },
  selected: {
    borderColor: colors.darkGreenhouseGreen,
    hoverBorderColor: colors.darkGreenhouseGreen,
    textColor: colors.darkestGrey,
    backgroundColor: colors.white,
    hoverColor: colors.lightestGrey,
    iconColor: colors.mediumGrey,
    iconHoverColor: colors.darkestGrey,
    iconHoverBGColor: colors.lightBlue,
  },
  unavailable: {
    borderColor: colors.lightGrey,
    hoverBorderColor: colors.lightGrey,
    textColor: colors.darkGrey,
    backgroundColor: colors.white,
    hoverColor: colors.lightestGrey,
    iconColor: colors.mediumGrey,
    iconHoverColor: colors.darkestGrey,
    iconHoverBGColor: colors.lightBlue,
  },
};

const birchTheme = {
  default: {
    borderColor: PrimaryPalette.lightGrey,
    hoverBorderColor: PrimaryPalette.darkGrey,
    textColor: PrimaryPalette.mediumEvergreen,
    backgroundColor: PrimaryPalette.lightGrey,
    hoverColor: PrimaryPalette.lightGrey,
    iconColor: PrimaryPalette.mediumEvergreen,
    iconHoverColor: PrimaryPalette.lightGrey,
    iconHoverBGColor: PrimaryPalette.mediumEvergreen,
  },
  error: {
    borderColor: PrimaryPalette.lightGrey,
    hoverBorderColor: PrimaryPalette.darkPoppy,
    textColor: PrimaryPalette.darkPoppy,
    backgroundColor: PrimaryPalette.lightGrey,
    hoverColor: PrimaryPalette.lightGrey,
    iconColor: PrimaryPalette.mediumEvergreen,
    iconHoverColor: PrimaryPalette.lightGrey,
    iconHoverBGColor: PrimaryPalette.mediumEvergreen,
  },
  selected: {
    borderColor: PrimaryPalette.mediumEvergreen,
    hoverBorderColor: PrimaryPalette.mediumEvergreen,
    textColor: PrimaryPalette.mediumEvergreen,
    backgroundColor: PrimaryPalette.lightGrey,
    hoverColor: PrimaryPalette.lightGrey,
    iconColor: PrimaryPalette.mediumEvergreen,
    iconHoverColor: PrimaryPalette.lightGrey,
    iconHoverBGColor: PrimaryPalette.mediumEvergreen,
  },
  unavailable: {
    borderColor: PrimaryPalette.lightGrey,
    hoverBorderColor: PrimaryPalette.darkGrey,
    textColor: PrimaryPalette.mediumEvergreen,
    backgroundColor: PrimaryPalette.lightGrey,
    hoverColor: PrimaryPalette.lightGrey,
    iconColor: PrimaryPalette.mediumEvergreen,
    iconHoverColor: PrimaryPalette.lightGrey,
    iconHoverBGColor: PrimaryPalette.mediumEvergreen,
  },
};

export { azaleaTheme, birchTheme };
